export default "__VITE_ASSET__bcb61ca9__"